/**
 * @generated SignedSource<<f2f2de30ef4468a7ac6c0b16668f69f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteFinderPageBarLineMask_mask$data = {
  readonly mask_download_url: string;
  readonly " $fragmentType": "NoteFinderPageBarLineMask_mask";
};
export type NoteFinderPageBarLineMask_mask$key = {
  readonly " $data"?: NoteFinderPageBarLineMask_mask$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageBarLineMask_mask">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteFinderPageBarLineMask_mask",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mask_download_url",
      "storageKey": null
    }
  ],
  "type": "MusicParseStepDataBarLineProcessorMask",
  "abstractKey": null
};

(node as any).hash = "fb66712b5e09a4d934b867fc5fb86184";

export default node;
